module.exports = __webpack_public_path__ + "img/allottee3_7-8-2021.38efd112.jpg";